






















































import { Component, Vue, Prop, Watch } from "vue-property-decorator"
@Component({})
export default class voucherInfo extends Vue {
    @Prop({ type: Number })
    isInsert: any;

    @Prop({ type: Boolean })
    isCheck: any;

    @Prop({ type: Object })
    disabledDate: any;

    @Prop([String, Number])
    voucherNo: any;

    noCopy: any = this.voucherNo;
    accessoryNum: string = "";
    dateTime: string = "";

    @Watch("voucherNo")
    voucherNoChange(val: any) {
        this.noCopy = val;
    }

    changeNo(val: any) {
        if (val != "") {
            var no = parseInt(val);
            if (no < 100 && no >= 10) {
                this.noCopy = "0" + no;
            } else if (no < 10) {
                this.noCopy = "00" + no;
            } else {
                this.noCopy = no
            }
        } else {
            this.noCopy = val
        }
        this.$emit("changeNo", this.noCopy)
    }

    changeDate(val: any) {
        this.$emit("changeDate", val, (<any>this.$parent).dateTime)
    }

    changeAcc(val: any) {
        this.$emit("changeAcc", val)
    }

    // 头部信息（凭证号，日期，附件）快捷键 
    toDate(e: any) {
        (<any>document.querySelector(".voucherDatePicker input")).focus()
    }
    toAcc() {
        let pickerPanel: any = document.querySelector(".el-picker-panel"),
            elInput: any = document.querySelector(".accessoryNumContainer input");
        pickerPanel.style.display = "none"
        elInput.focus()
    }
    toSum() {
        (<any>document.querySelector(".rowSummary textarea")).focus()
    }
}
